import script from "./NewUser.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUser.vue?vue&type=script&setup=true&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=0d676d54&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d676d54"]])

export default __exports__